import { ImportacionMasivaResponseI, infoFetchGetPciI, makePci } from "dtos/pci";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

export const postPci = async ({ params }: FetchCallbackI) => {
  console.log("params finales: ", params);
  const response = await sendRequest<infoFetchGetPciI>({
    method: "POST_JSON",
    uri: ENDPOINTS.PCI,
    params: servicesUtils.removeNullNonEmptyParamsInFilters(params),
  });
  console.log("Respuesta del back", response);
  
  return response;
};

export const postImportacionMasivaPci = async ({ params, images }: FetchCallbackI) => {
  console.log("params finales: ", params);
  const response = await sendRequest<ImportacionMasivaResponseI>({
    method: "POST",
    uri: ENDPOINTS.PCI + "/importacion-masiva",
    images: images,
    params: servicesUtils.removeNullNonEmptyParamsInFilters(params),
  });
  console.log("Respuesta del back", response);
  
  return response;
};

export const putPci = async ({ params }: FetchCallbackI) => {
  const id = params?.id;
  console.log("PARAMS PARA EDITAR: ", params);
  const response = await sendRequest<infoFetchGetPciI>({
    method: "PUT_JSON",
    uri: ENDPOINTS.PCI + "/" + id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  return response;
};

export const getPcis = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetPciI>
  >({
    method: "GET",
    uri: ENDPOINTS.PCI,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  console.log("response", response);

  const elementosFormated = response.elementos.map((ctElemento) =>
    makePci(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const getPciById = async (id: any, params?: any) => {
  const response = await sendRequest<infoFetchGetPciI | undefined>({
    method: "GET",
    uri: ENDPOINTS.PCI + "/" + id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  console.log("response PCII: ", response);
  return response ? makePci(response) : undefined;
};

export const deletePci = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.PCI + "/" + id,
  });
  return response;
};
